"use client";

import React from "react";

interface SelectOption {
  value: string;
  label: string;
}

interface SelectInputProps {
  label?: string;
  id?: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  required?: boolean;
  options?: SelectOption[];
  placeholder?: string;
  disabled?: boolean;
}

export default function SelectInput({
  label,
  id,
  name,
  value,
  onChange,
  required = false,
  options = [],
  placeholder = "Vyber možnosť",
  disabled = false,
}: SelectInputProps) {
  const selectClass = `border border-[#D9D9D9] rounded-md p-2.5 w-full appearance-none ${
    disabled ? "bg-[#F0F0F0] text-gray-500 cursor-not-allowed" : "bg-[#FFFFFF]"
  } ${!value ? "text-gray-400" : disabled ? "text-gray-500" : "text-black"}`;

  // Localize the browser's default "Please select an item in the list" popup.
  const handleInvalid = (e: React.FormEvent<HTMLSelectElement>) => {
    const el = e.currentTarget;
    el.setCustomValidity(
      el.validity.valueMissing
        ? label
          ? `Prosím, vyberte možnosť pre „${label}“.`
          : "Prosím, vyberte možnosť."
        : "",
    );
  };

  // Clear the custom message on change so the field can become valid again.
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    e.currentTarget.setCustomValidity("");
    onChange(e);
  };

  return (
    <div className='flex flex-col relative'>
      {label && (
        <label htmlFor={id || name} className='mb-1 text-[15px]'>
          {label}
          {required && "*"}
        </label>
      )}
      <div className='relative'>
        <select
          id={id || name}
          name={name}
          value={value}
          onChange={handleChange}
          onInvalid={handleInvalid}
          required={required}
          disabled={disabled}
          className={`${selectClass} pr-10`}
        >
          <option value='' disabled hidden>
            {placeholder}
          </option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          className='absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none'
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
          strokeWidth={2}
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M19 9l-7 7-7-7'
          />
        </svg>
      </div>
    </div>
  );
}
